import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { MODULE_ADS_PARTNER } from "shared/constants";
import PermissionDeniedPage from "components/PermissionDenied";

const Partner = React.lazy(
  () => import("containers/ServiceManagement/AdsPartner")
);

function AdsPartnerRoute() {
  return (
    <Route
      path="ads-partner"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<Partner />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_ADS_PARTNER]}
          />
        </Suspense>
      }
    />
  );
}

export default AdsPartnerRoute;
